// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsColumnsPage_pageDescription__2rDhE","formsList":"ProjectsColumnsPage_formsList__4QpU2"};